module.exports = __webpack_public_path__ + "static/media/salad.05bdc0a4.svg";